"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _luxon = require("luxon");

var _ = require(".");

var Queue =
/** @class */
function () {
  function Queue() {
    this.id = null;
    this.sampleName = null;
    this.notes = null;
    this.comments = null;
    this.createdAt = null;
    this.updatedAt = null;
    this.practiceId = null;
    this.veterinarianId = null;
    this.labTechId = null;
    this.animalId = null;
    this.testTypeId = null;
    this.practice = null;
    this.veterinarian = null;
    this.labTech = null;
    this.animal = null;
    this.testType = null;
    this.sourceId = null;
  }

  Queue.thaw = function (queueObj) {
    var _a, _b;

    if (queueObj == null) return null;
    var test = new Queue();

    if (queueObj.id != null) {
      test.setId(queueObj.id);
    }

    if (queueObj.sampleName != null) {
      test.setSampleName(queueObj.sampleName);
    }

    if (queueObj.comments != null) {
      test.setComments(queueObj.comments);
    }

    if (queueObj.createdAt != null) {
      test.setCreatedAt((_a = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(queueObj.createdAt)) !== null && _a !== void 0 ? _a : null);
    }

    if (queueObj.updatedAt != null) {
      test.setUpdatedAt((_b = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(queueObj.updatedAt)) !== null && _b !== void 0 ? _b : null);
    }

    if (queueObj.practiceId != null) {
      test.setPracticeId(queueObj.practiceId);
    }

    if (queueObj.veterinarianId != null) {
      test.setVeterinarianId(queueObj.veterinarianId);
    }

    if (queueObj.labTechId != null) {
      test.setLabTechId(queueObj.labTechId);
    }

    if (queueObj.animalId != null) {
      test.setAnimalId(queueObj.animalId);
    }

    if (queueObj.testTypeId != null) {
      test.setTestTypeId(queueObj.testTypeId);
    }

    if (queueObj.practice != null) {
      test.setPractice(_.Practice.thaw(queueObj.practice));
    }

    if (queueObj.veterinarian != null) {
      test.setVeterinarian(_.Veterinarian.thaw(queueObj.veterinarian));
    }

    if (queueObj.labTech != null) {
      test.setLabTech(_.LabTech.thaw(queueObj.labTech));
    }

    if (queueObj.animal != null) {
      test.setAnimal(_.Animal.thaw(queueObj.animal));
    }

    if (queueObj.testType != null) {
      test.setTestType(_.TestType.thaw(queueObj.testType));
    }

    if (queueObj.sourceId != null) {
      test.setSourceId(queueObj.sourceId);
    }

    return test;
  };

  Queue.thawList = function (queueObjList) {
    if (queueObjList == null) {
      return [];
    }

    var tests = [];

    for (var i = 0; i < queueObjList.length; i++) {
      tests.push(Queue.thaw(queueObjList[i]));
    }

    return tests;
  };

  Queue.freeze = function (test) {
    var _a, _b, _c, _d;

    if (test == null) {
      return null;
    }

    var queueObj = {};

    if (test.getId() != null) {
      queueObj.id = test.getId();
    }

    if (test.getSampleName() != null) {
      queueObj.sampleName = test.getSampleName();
    }

    if (test.getComments() != null) {
      queueObj.comments = test.getComments();
    }

    if (test.getCreatedAt() != null) {
      queueObj.createdAt = (_b = (_a = test.getCreatedAt()) === null || _a === void 0 ? void 0 : _a.toISO()) !== null && _b !== void 0 ? _b : null;
    }

    if (test.getUpdatedAt() != null) {
      queueObj.updatedAt = (_d = (_c = test.getUpdatedAt()) === null || _c === void 0 ? void 0 : _c.toISO()) !== null && _d !== void 0 ? _d : null;
    }

    if (test.getPracticeId() != null) {
      queueObj.practiceId = test.getPracticeId();
    }

    if (test.getVeterinarianId() != null) {
      queueObj.veterinarianId = test.getVeterinarianId();
    }

    if (test.getLabTechId() != null) {
      queueObj.labTechId = test.getLabTechId();
    }

    if (test.getAnimalId() != null) {
      queueObj.animalId = test.getAnimalId();
    }

    if (test.getTestTypeId() != null) {
      queueObj.testTypeId = test.getTestTypeId();
    }

    if (test.getPractice() != null) {
      queueObj.practice = _.Practice.freeze(test.getPractice());
    }

    if (test.getVeterinarian() != null) {
      queueObj.veterinarian = _.Veterinarian.freeze(test.getVeterinarian());
    }

    if (test.getLabTech() != null) {
      queueObj.labTech = _.LabTech.freeze(test.getLabTech());
    }

    if (test.getAnimal() != null) {
      queueObj.animal = _.Animal.freeze(test.getAnimal());
    }

    if (test.getTestType() != null) {
      queueObj.testType = _.TestType.freeze(test.getTestType());
    }

    if (test.getSourceId() != null) {
      queueObj.sourceId = test.getSourceId();
    }

    return queueObj;
  };

  Queue.freezeList = function (tests) {
    if (tests == null) {
      return [];
    }

    var queueObjList = [];

    for (var i = 0; i < tests.length; i++) {
      queueObjList.push(Queue.freeze(tests[i]));
    }

    return queueObjList;
  };
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  Queue.prototype.setId = function (id) {
    this.id = id;
  };

  Queue.prototype.setSampleName = function (sampleName) {
    this.sampleName = sampleName;
  };

  Queue.prototype.setNotes = function (notes) {
    this.notes = notes;
  };

  Queue.prototype.setComments = function (comments) {
    this.comments = comments;
  };

  Queue.prototype.setCreatedAt = function (createdAt) {
    this.createdAt = createdAt;
  };

  Queue.prototype.setUpdatedAt = function (updatedAt) {
    this.updatedAt = updatedAt;
  };

  Queue.prototype.setPracticeId = function (practiceId) {
    this.practiceId = practiceId;
  };

  Queue.prototype.setVeterinarianId = function (veterinarianId) {
    this.veterinarianId = veterinarianId;
  };

  Queue.prototype.setLabTechId = function (labTechId) {
    this.labTechId = labTechId;
  };

  Queue.prototype.setAnimalId = function (animalId) {
    this.animalId = animalId;
  };

  Queue.prototype.setTestTypeId = function (testTypeId) {
    this.testTypeId = testTypeId;
  };

  Queue.prototype.setPractice = function (practice) {
    this.practice = practice;
  };

  Queue.prototype.setVeterinarian = function (veterinarian) {
    this.veterinarian = veterinarian;
  };

  Queue.prototype.setLabTech = function (labTech) {
    this.labTech = labTech;
  };

  Queue.prototype.setAnimal = function (animal) {
    this.animal = animal;
  };

  Queue.prototype.setTestType = function (testType) {
    this.testType = testType;
  };

  Queue.prototype.setSourceId = function (sourceId) {
    this.sourceId = sourceId;
  };
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  Queue.prototype.getId = function () {
    return this.id;
  };

  Queue.prototype.getSampleName = function () {
    return this.sampleName;
  };

  Queue.prototype.getNotes = function () {
    return this.notes;
  };

  Queue.prototype.getComments = function () {
    return this.comments;
  };

  Queue.prototype.getCreatedAt = function () {
    return this.createdAt;
  };

  Queue.prototype.getUpdatedAt = function () {
    return this.updatedAt;
  };

  Queue.prototype.getPracticeId = function () {
    return this.practiceId;
  };

  Queue.prototype.getVeterinarianId = function () {
    return this.veterinarianId;
  };

  Queue.prototype.getLabTechId = function () {
    return this.labTechId;
  };

  Queue.prototype.getAnimalId = function () {
    return this.animalId;
  };

  Queue.prototype.getTestTypeId = function () {
    return this.testTypeId;
  };

  Queue.prototype.getPractice = function () {
    return this.practice;
  };

  Queue.prototype.getVeterinarian = function () {
    return this.veterinarian;
  };

  Queue.prototype.getLabTech = function () {
    return this.labTech;
  };

  Queue.prototype.getAnimal = function () {
    return this.animal;
  };

  Queue.prototype.getTestType = function () {
    return this.testType;
  };

  Queue.prototype.getSourceId = function () {
    return this.sourceId;
  };

  return Queue;
}();

var _default = Queue;
exports.default = _default;